import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { clearLocalStoragePreserving } from 'src/@shared/auth/auth-state';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  constructor(private datePipe: DatePipe) {}

  getToken(): string | null {
    return localStorage.getItem('BearerToken');
  }

  getLocalStorageItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  setLocalStorageItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  clearSession(): void {
    clearLocalStoragePreserving();
    sessionStorage.clear();
  }

  buildSiteHeaders(includeContentType: boolean = true): HttpHeaders | undefined {
    const token = this.getToken();
    if (!token) {
      return undefined;
    }

    const url = new URL(window.location.href);
    const timeZoneValue = this.datePipe.transform(new Date(), 'MM/dd/yyyy hh:mm:ss a');
    const localTimeZoneValue = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timeZoneAbbr = this.getTimezoneAbbreviation();

    let headers = new HttpHeaders();
    if (includeContentType) {
      headers = headers.set('Content-Type', 'application/json');
    }
    const siteId = this.siteIdFromPath(url.pathname);
    if (siteId) {
      headers = headers.set('siteid', siteId);
    }
    headers = headers.set('timeZone', timeZoneValue || '');
    headers = headers.set('localTimeZone', localTimeZoneValue);
    headers = headers.set('timeZoneAbbr', timeZoneAbbr);
    return headers;
  }

  /**
   * The site id from a /paybev/:siteId URL, or null elsewhere (Switch Account, /account, login).
   * Sending the second path segment regardless put "undefined" or "user-profile" in the header,
   * which the API treats as a site the user cannot access and answers with 401.
   */
  private siteIdFromPath(pathname: string): string | null {
    const match = /^\/paybev\/([^/]+)/.exec(pathname);
    return match ? match[1] : null;
  }

  buildFormHeaders(): HttpHeaders | undefined {
    const token = this.getToken();
    if (!token) {
      return undefined;
    }
    const url = new URL(window.location.href);
    let headers = new HttpHeaders();
    headers = headers.set('authorization', 'Bearer ' + token);
    const siteId = this.siteIdFromPath(url.pathname);
    if (siteId) {
      headers = headers.set('siteid', siteId);
    }
    return headers;
  }

  private getTimezoneAbbreviation(): string {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZoneName: 'short',
    }).formatToParts(new Date());
    const tzPart = parts.find((p) => p.type === 'timeZoneName');
    return tzPart?.value ?? Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
